import { lazy, Suspense, memo } from 'react';

const DevToolEntry = lazy(() => import('./entry'));

export const DevTool = memo(() => {
  if (process.env.NODE_ENV === 'development') {
    return <Suspense fallback={null}>{<DevToolEntry />}</Suspense>;
  } else {
    return null;
  }
});
